import {
  CLOSE_SIDE_NAV,
  OPEN_SIDE_NAV,
  SHOW_AUTH_POPUP,
  SET_HEADER_TITLE,
  CHAT_SUCCESS,
  CHAT_FAILURE,
} from './actionType'

export const initialState = {
  sideNavIsOpen: false,
  openPopup: 0,
  popupType: '',
  headerTitle: '',
  chatLoading: false,
  chatError: null,
  lastChatResponse: null,
}

export default function layoutReducer(state = initialState, action = {}) {
  switch (action.type) {
    case OPEN_SIDE_NAV: {
      const newState = {
        ...state,
        sideNavIsOpen: true,
      }
      return newState
    }
    case CLOSE_SIDE_NAV: {
      const newState = {
        ...state,
        sideNavIsOpen: false,
      }
      return newState
    }
    case SHOW_AUTH_POPUP: {
      const { payload } = action
      const newState = {
        ...state,
        openPopup: state.openPopup + 1,
        popupType: payload,
      }
      return newState
    }
    case SET_HEADER_TITLE: {
      const { payload } = action
      const newState = {
        ...state,
        headerTitle: payload,
      }
      return newState
    }
    case CHAT_SUCCESS:
      return {
        ...state,
        chatLoading: false,
        lastChatResponse: action.payload.chatResponse,
      }
    case CHAT_FAILURE:
      return {
        ...state,
        chatLoading: false,
        chatError: action.error,
      }
    default:
      return state
  }
}
